



















import { FitDatePicker } from '@tencent/wphk-ui';
import { defineComponent } from '@vue/composition-api';
import { useRecordList } from '../../store/record-list';
import { ArrowDownIcon } from '@tencent/wphk-icon-vue';
import { i18n, getLang } from '../../i18n';

export default defineComponent({
  components: {
    DatePicker: FitDatePicker,
    ArrowDownIcon,
  },
  setup() {
    // 注意此处month不可以作为ref传入给picker组件，否则在picker内部也会修改month的值，并且抛出change事件，导致死循环
    const { setMonth, month } = useRecordList();
    const handleChange = (value) => {
      const newMonth = new Date(value);
      setMonth(newMonth);
    };

    const lang = getLang();
    const isEn = lang === 'en';
    const outputformat = isEn ? 'MMM YYYY' : 'YYYY年 MM月';
    const previewformat = isEn ? 'MMM-YYYY' : 'YYYY-MM';
    // 注意，此处必须传入 'day' ，组件内部实现使用了缓存，不传会导致使用了错误的缓存，这属于设计缺陷
    const suffix = isEn ? ['', '', 'day'] : ['年', '月', '日'];
    // 组件内部没有实现不同语言的实现，所以必须自己传入
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const labelTransform = (value, type, suffix) => {
      if (isEn && type === 'month') {
        const monthName = monthNames[value - 1];
        return monthName;
      }
      return value + suffix;
    };

    return { month, handleChange, i18n, outputformat, previewformat, suffix, labelTransform };
  },
});
